import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { ClearGiftSummaryReducer, GetGiftSummaryReducer } from './reducers';
import { GetGiftSummary } from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'giftSummary',
  initialState,
  reducers: {
    ClearGiftSummary: ClearGiftSummaryReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetGiftSummary, GetGiftSummaryReducer);
  },
});

export default slice.reducer;
